<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">
        <futurocoins-from-mining></futurocoins-from-mining>
        <create-code></create-code>
        <codes-list></codes-list>
    </b-col>
</template>

<script>
    import CreateCode from './codes/CreateCode.vue'
    import CodesList from './codes/CodesList.vue'
    import FuturocoinsFromMining from './dashboard/FuturocoinsFromMining.vue'

    export default {
        dependencies: ['code', 'popup'],
        components: { CreateCode, CodesList, FuturocoinsFromMining },
        mounted() {
            if(this.$route.params.code) {
                this.code.confirmCode(this.$route.params.code);
                this.$router.push({ path: '/business/codes' });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .space{
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/CodesContent.vue